import React from "react";
import UsersList from "./UsersList";
import ModernMonthPicker from "./ModernMonthPicker";
const Etape1 = ({
  renderError,
  formData,
  setFormData,
  handleChange,
  handleDepensesActiviteExterneChange,
  errorMessage,
  isReadOnly,
  page,
  rejectedRequest,
  isCheckingRejectedRequest,
  rejectedRequestLookupError,
}) => {

  // Function to handle user selection and trigger form change
  const handleUserSelect = (user, fieldName) => {
    handleChange({
      target: {
        name: fieldName,
        value: {
          nom: user.displayName,
          email: user.mail,
          userId: user.id,
          matricule :user.employeeId,
          etatDemande:""
        },
      },
    });
  };
 
  const RadioQuestion = ({ name, label, value, onChange }) => (

    <div className="grid w-full grid-cols-1 items-center gap-3 md:grid-cols-[minmax(0,48rem)_auto] md:justify-start md:gap-5">
  <label className="flex items-center text-sm font-medium text-slate-700">
    {label} <span className="text-red-500 ml-1">*</span>
  </label>

  <div className="flex items-center gap-2">
          {["oui", "non"].map((option) => {
            const isSelected = value === option;

            return (
              <label
                key={option}
                className={`
                  flex h-10 min-w-[76px] items-center justify-center
                  px-4 rounded-lg cursor-pointer
                  text-[15px] font-medium
                  border transition-all duration-200
                  focus-within:ring-2 focus-within:ring-blue-300 focus-within:ring-offset-1
                  ${
                    isSelected
                      ? "bg-blue-100 text-blue-600 border-blue-300"
                      : "bg-white text-gray-500 border-gray-300 hover:border-gray-400 hover:text-gray-600"
                  }
                `}
              >
                <input
                  type="radio"
                  name={name}
                  value={option}
                  checked={isSelected}
                  onChange={onChange}
                  className="sr-only"
                  disabled={isReadOnly}
                />
                {option.charAt(0).toUpperCase() + option.slice(1)}
              </label>
            );
          })}
        </div>
</div>

  );
  
  
const RadioQuestionmembre = ({
    name,
    label,
    value,
    onChange,
    inline = false,
  }) => {
    return (
      <div
        className={
          inline
            ? "flex w-full flex-wrap items-center gap-x-5 gap-y-2"
            : "flex w-full flex-col gap-2"
        }
      >
        <label className="text-sm font-medium text-slate-700">
          {label} <span className="text-red-400 ml-1">*</span>
          
        </label>

        <div className="flex items-center gap-3">
          {["oui", "non"].map((option) => {
            const isSelected = value === option;

            return (
              <label
                key={option}
                className={`
                  flex h-10 min-w-[76px] items-center justify-center
                  px-4 rounded-lg cursor-pointer
                  text-[15px] font-medium
                  border transition-all duration-200
                  focus-within:ring-2 focus-within:ring-blue-300 focus-within:ring-offset-1
                  ${
                    isSelected
                      ? "bg-blue-100 text-blue-600 border-blue-300"
                      : "bg-white text-gray-500 border-gray-300 hover:border-gray-400 hover:text-gray-600"
                  }
                `}
              >
                <input
                  type="radio"
                  name={name}
                  value={option}
                  checked={isSelected}
                  onChange={onChange}
                  className="sr-only"
                  disabled={isReadOnly}
                />
                {option.charAt(0).toUpperCase() + option.slice(1)}
              </label>
            );
          })}
        </div>
      </div>
    );
  };
  /************************************************************************/

  return (
    <div className="px-4 py-6 sm:px-6 lg:px-8">
    
        {/* <h1 className="text-2xl font-bold mb-6 text-black">
          Information générale
        </h1> */}
        <dl className="ml-auto grid w-full max-w-md grid-cols-1 rounded-lg border border-gray-200 bg-white text-sm shadow-sm sm:w-fit sm:max-w-none sm:grid-cols-[auto_auto]">
          <div className="min-w-0 px-4 py-3 sm:px-5">
            <dt className="text-xs font-medium text-slate-500">Numéro de formulaire</dt>
            <dd className="mt-1 break-words font-semibold text-slate-800">
              {formData.numeroFormulaire}
            </dd>
          </div>
          <div className="min-w-0 border-t border-gray-100 px-4 py-3 sm:border-l sm:border-t-0 sm:px-5">
            <dt className="text-xs font-medium text-slate-500">Date</dt>
            <dd className="mt-1 font-medium text-slate-700">
              {formData.dateSoumission
                ? new Intl.DateTimeFormat("fr-CA", {
                    day: "numeric",
                    month: "short",
                    year: "numeric",
                    timeZone: "UTC",
                  }).format(new Date(formData.dateSoumission))
                : "—"}
            </dd>
          </div>
        </dl>
        
        <div className="my-6 flex w-full justify-center">
  <div className="w-fit max-w-full rounded-lg border border-blue-100 border-l-4 border-l-blue-500 bg-blue-50 px-4 py-3 text-blue-800 shadow-sm">
    <p className="flex items-center gap-2 text-lg font-semibold">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-5 w-5 flex-none text-blue-600"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M9 17v-2a4 4 0 014-4h6m-6 0V9m0 0H9m3 0h3"
        />
      </svg>
      Réclamation mensuelle de dépenses d'emploi
    </p>
  </div>
</div>

        <div className="mt-8 w-full rounded-t-xl bg-gradient-to-r from-[#182a43] to-[#40516a] py-3 shadow-sm">
  <p className="ml-4 flex items-center text-base font-semibold tracking-wide text-white">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="mr-2 h-4 w-4 text-blue-400"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M5.121 17.804A13.937 13.937 0 0112 15c2.21 0 4.27.534 6.121 1.47M15 10a3 3 0 11-6 0 3 3 0 016 0z"
      />
    </svg>
    Information du membre du personnel
  </p>
</div>

        <div className="mt-5 w-full rounded-xl border border-gray-200 bg-white p-4 shadow-sm sm:p-5">
          <div className="mb-3 w-full max-w-6xl">
            <p className="text-sm font-semibold text-gray-800">
              Renseignements du profil
            </p>
            <p className="mt-1 text-[13px] leading-5 text-slate-600">
              Ces informations proviennent de votre compte professionnel.
            </p>
          </div>

          <div className="grid w-full max-w-6xl grid-cols-1 gap-x-8 gap-y-3 sm:grid-cols-2">
            {[
              { label: "Nom", value: formData.nom },
              { label: "Courriel", value: formData.courriel },
              { label: "Lieu de travail", value: formData.LieuTravail },
              { label: "Poste", value: formData.posteOccupe },
            ].map(({ label, value }) => (
              <div key={label} className="min-w-0 py-1.5">
                <p className="text-[13px] font-semibold uppercase tracking-wide text-slate-600">
                  {label}
                </p>
                <p className="mt-1 break-words text-[15px] font-medium text-slate-900">
                  {value || "—"}
                </p>
              </div>
            ))}
          </div>

          {renderError("posteOccupe")}
          {renderError("LieuTravail")}

          <div className="mt-4 w-full max-w-6xl border-t border-gray-200 pt-4">
            <p className="mb-4 text-sm font-semibold text-gray-800">
              Détails de la soumission
            </p>
            <div className="grid grid-cols-1 items-start gap-x-6 gap-y-4 lg:grid-cols-2">
            <div className="min-w-0 lg:col-span-2">
            <RadioQuestionmembre
              name="soumisAutreMembre"
              label="Soumis de la part d'un autre membre du personnel"
              value={formData.soumisAutreMembre}
              onChange={handleChange}
              inline
            />
            {renderError("soumisAutreMembre")}
            </div>

        {formData.soumisAutreMembre === "oui" && (
        <>
          <div className="w-full min-w-0">
            <label
              htmlFor="adresse"
              className="block text-sm font-medium text-slate-700"
            >
              Soumis de la part de <span className="text-xl text-red-900" >*</span> :
            </label>
            <div className="relative">
              {/* Add the UsersList component with the callback for user selection */}
              {isReadOnly===false && !formData?.soumisParAutreMembre?.nom && (
                <UsersList onUserSelect={(user) => handleUserSelect(user, "soumisParAutreMembre")} initialValue={formData.soumisParAutreMembre.email}/>
              )}

                {/* Display the selected user's information */}
                {formData?.soumisParAutreMembre?.nom && (
                  <div className="flex min-h-[62px] items-center gap-3 rounded-lg border border-gray-200 bg-white px-4 py-3 shadow-sm">
                    {/* Avatar */}
                    <div className="flex h-9 w-9 flex-none items-center justify-center rounded-full bg-gray-100 text-sm font-semibold text-gray-600">
                      {formData.soumisParAutreMembre.nom.charAt(0).toUpperCase()}
                    </div>

                    {/* Infos */}
                    <div className="flex flex-col">
                      <span className="text-sm font-semibold text-gray-900">
                        {formData.soumisParAutreMembre.nom}
                      </span>
                      <span className="text-sm text-gray-700">
                        {formData.soumisParAutreMembre.email}
                      </span>
                    </div>

                    {/* Bouton supprimer */}
                    {!isReadOnly && (
                      <button
                        onClick={() =>
                          setFormData((prev) => ({
                            ...prev,
                            soumisParAutreMembre: {
                            },
                          }))
                        }
                        className="ml-auto text-red-400 hover:text-red-500 transition"
                      >
                        ✕
                      </button>
                    )}
                  </div>
                )}
            </div>
            {renderError("soumisParAutreMembre")}
          </div>
          <div className="w-full min-w-0">
          <label
              htmlFor="dateEntreeEnVigueur"
              className="block text-sm font-medium text-slate-700"
            >
              Raison de soumission <span className="text-xl text-red-900" >*</span> :
            </label>
            <textarea
              placeholder="Ajoutez un commentaire..."
    className="mt-1.5 w-full rounded-lg border border-slate-300 bg-white px-3 py-2.5 text-[15px] text-slate-800 shadow-sm outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-100"
              rows="2"
              id="commentaireRaisonSoumission"
              name="commentaireRaisonSoumission"
              value={formData.commentaireRaisonSoumission}
              onChange={handleChange}
              readOnly={isReadOnly}
            ></textarea>
            {renderError("commentaireRaisonSoumission")}
          </div>
        </>
        )}
            </div>
          </div>
        <div className="mt-5 grid w-full max-w-6xl grid-cols-1 gap-x-6 gap-y-4 border-t border-gray-100 pt-5 md:grid-cols-2 xl:grid-cols-3">
          <div className="md:col-span-2 xl:col-span-3">
            <p className="text-sm font-semibold text-gray-800">
              Responsables de l’approbation
            </p>
            <p className="mt-1 text-[13px] leading-5 text-slate-600">
              Recherchez et sélectionnez les personnes responsables.
            </p>
          </div>
          <div className="w-full min-w-0">
            <label
              htmlFor="fileUpload"
              className="block text-sm font-medium text-slate-700"
            >
              Superviseur <span className="text-xl text-red-900" >*</span> :
            </label>
            <div className="relative">
              {/* Add the UsersList component with the callback for user selection */}
              {isReadOnly===false &&!formData?.managerInfo?.nom && (
                <UsersList onUserSelect={(user) => handleUserSelect(user, "managerInfo")} initialValue={formData.managerInfo.email}/> 
                )}

                {/* Display the selected user's information */}
                {formData?.managerInfo?.nom && (
                  <div className="flex min-h-[62px] items-center gap-3 rounded-lg border border-gray-200 bg-white px-4 py-3 shadow-sm">
                    {/* Avatar */}
                    <div className="flex h-9 w-9 flex-none items-center justify-center rounded-full bg-gray-100 text-sm font-semibold text-gray-600">
                      {formData.managerInfo.nom.charAt(0).toUpperCase()}
                    </div>

                    {/* Infos */}
                    <div className="flex flex-col">
                      <span className="text-sm font-semibold text-gray-900">
                        {formData.managerInfo.nom}
                      </span>
                      <span className="text-sm text-gray-700">
                        {formData.managerInfo.email}
                      </span>
                    </div>

                    {/* Bouton supprimer */}
                    {!isReadOnly && (
                      <button
                        onClick={() =>
                          setFormData((prev) => ({
                            ...prev,
                            managerInfo: {
                              nom: "",
                              email: "",
                              userId: "",
                              matricule: "",
                              etatDemande: "",
                            },
                          }))
                        }
                        className="ml-auto text-red-400 hover:text-red-500 transition"
                      >
                        ✕
                      </button>
                    )}
                  </div>
                )}
            </div>
            {renderError("managerInfo")}
          </div>
          <div className="w-full min-w-0">
          <RadioQuestionmembre
          name="verificationDelegue"
          label="Vérification effectuée par un(e) délégué(e)"
          value={formData.verificationDelegue}
          onChange={handleChange}
        />
  {/* <label
    htmlFor="verificationDelegue"
    className="block text-sm font-semibold text-blue-900 mb-1"
  >
    Vérification effectuée par un(e) délégué(e) <span className="text-red-500">*</span> :
  </label>

  <div className="mt-2 flex space-x-3">
    {["oui", "non"].map((option) => {
      const isSelected = formData.verificationDelegue === option;
      return (
        <label
          key={option}
          className={`cursor-pointer px-3 py-1 text-sm rounded-md border transition-colors duration-150
            ${isSelected ? "bg-blue-600 text-white border-blue-600" : "bg-gray-100 text-gray-700 border-gray-300 hover:bg-gray-200"}`}
        >
          <input
            type="radio"
            name="verificationDelegue"
            value={option}
            onChange={handleChange}
            className="hidden"
            disabled={isReadOnly}
          />
          {option.charAt(0).toUpperCase() + option.slice(1)}
        </label>
      );
    })}
  </div> */}
</div>

        {formData.verificationDelegue === "oui" && (
          <div className="w-full min-w-0">
              <label
                htmlFor="fileUpload"
                className="block text-sm font-medium text-slate-700"
              >
              Délégué(e) <span className="text-xl text-red-900" >*</span>:
              </label>
              <div className="relative">
                {/* Add the UsersList component with the callback for user selection */}
                {isReadOnly===false && !formData?.delegueInfo?.nom && (
                   <UsersList onUserSelect={(user) => handleUserSelect(user, "delegueInfo")} initialValue={formData.delegueInfo.email}/>
                )}

                  {/* Display the selected user's information */}
                  {formData?.delegueInfo?.nom && (
                  <div className="flex min-h-[62px] items-center gap-3 rounded-lg border border-gray-200 bg-white px-4 py-3 shadow-sm">
                    {/* Avatar */}
                    <div className="flex h-9 w-9 flex-none items-center justify-center rounded-full bg-gray-100 text-sm font-semibold text-gray-600">
                      {formData.delegueInfo.nom.charAt(0).toUpperCase()}
                    </div>

                    {/* Infos */}
                    <div className="flex flex-col">
                      <span className="text-sm font-semibold text-gray-900">
                        {formData.delegueInfo.nom}
                      </span>
                      <span className="text-sm text-gray-700">
                        {formData.delegueInfo.email}
                      </span>
                    </div>

                    {/* Bouton supprimer */}
                    {!isReadOnly && (
                      <button
                        onClick={() =>
                          setFormData((prev) => ({
                            ...prev,
                            delegueInfo: {
                              nom: "",
                              email: "",
                              userId: "",
                              matricule: "",
                              ecole: "",
                              etatDemande: "",
                            },
                          }))
                        }
                        className="ml-auto text-red-400 hover:text-red-500 transition"
                      >
                        ✕
                      </button>
                    )}
                  </div>
                )}
              </div>
              {renderError("delegueInfo")}
            </div>)}
        </div>
        </div>
      
        <div className="mt-8 w-full rounded-t-xl bg-gradient-to-r from-[#182a43] to-[#40516a] py-3 shadow-sm">
  <p className="ml-4 flex items-center text-base font-semibold tracking-wide text-white">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="mr-2 h-4 w-4 text-yellow-400"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
      />
    </svg>
    Période de réclamation
  </p>
</div>


        <div className="mt-5 grid w-full grid-cols-1 gap-5 rounded-xl border border-gray-200 bg-white p-4 shadow-sm sm:p-5 md:grid-cols-[minmax(0,32rem)_minmax(0,1fr)]">
          <div className="w-full min-w-0">
            <label
              htmlFor="dateEntreeEnVigueur"
              className="block text-sm font-medium text-slate-700"
            >
              Mois <span className="text-xl text-red-900" >*</span> :
            </label>
              {(() => {
                const now = new Date();
                const year = now.getFullYear();
                const month = String(now.getMonth() + 1).padStart(2, "0");

                // mois courant (max)
                const maxMonth = `${year}-${month}`;

                // mois -12 (min)
                const past = new Date(now.setMonth(now.getMonth() - 12));
                const minYear = past.getFullYear();
                const minMonth = String(past.getMonth() + 1).padStart(2, "0");
                const minMonthValue = `${minYear}-${minMonth}`;

                return (
                  <ModernMonthPicker
                    value={formData.periodReclamation}
                    onChange={(value) =>
                      handleChange({
                        target: { name: "periodReclamation", value },
                      })
                    }
                    disabled={isReadOnly}
                    min={minMonthValue}
                    max={maxMonth}
                    ariaLabel="Choisir la période de réclamation"
                  />
                );
              })()}
            {renderError("periodReclamation")}
            {isCheckingRejectedRequest && (
              <p className="mt-2 text-xs text-slate-500">
                Vérification des demandes rejetées...
              </p>
            )}
            {rejectedRequest && (
              <div
                className="mt-3 rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm"
                role="status"
              >
                <div className="flex items-start gap-3">
                  <svg
                    className="mt-0.5 h-5 w-5 flex-none text-amber-600"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      fillRule="evenodd"
                      d="M8.485 2.495a1.75 1.75 0 0 1 3.03 0l6.28 10.86A1.75 1.75 0 0 1 16.28 16H3.72a1.75 1.75 0 0 1-1.515-2.645l6.28-10.86ZM10 6.75a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0v-3A.75.75 0 0 1 10 6.75Zm0 6a.875.875 0 1 0 0 1.75.875.875 0 0 0 0-1.75Z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <div>
                    <p className="font-semibold text-amber-900">
                      Une demande rejetée existe déjà pour cette période.
                    </p>
                    <p className="mt-1 text-xs font-medium text-amber-800">
                      Numéro de la demande :{" "}
                      <span className="font-mono font-semibold">
                        {rejectedRequest.numeroFormulaire}
                      </span>
                    </p>
                    <p className="mt-1 leading-5 text-amber-800">
                      Corrigez et soumettez de nouveau cette demande plutôt que de créer une nouvelle demande.
                    </p>
                    <a
                      href={`/formulaire?numeroFormulaire=${encodeURIComponent(
                        rejectedRequest.numeroFormulaire,
                      )}&page=Mes%20demandes`}
                      className="mt-2 inline-flex font-semibold text-amber-900 underline decoration-amber-400 underline-offset-2 hover:text-amber-700"
                    >
                      Corriger la demande rejetée →
                    </a>
                  </div>
                </div>
              </div>
            )}
            {rejectedRequestLookupError && (
              <p className="mt-2 text-xs text-red-600">
                {rejectedRequestLookupError}
              </p>
            )}
            {/* {errorMessage && (
              <p className="text-red-500 text-sm mt-2">{errorMessage}</p>
            )} */}
            {(errorMessage || formData.periodDepasseTroisMois==="oui") && (
              <p className="text-red-500 text-sm mt-2">{errorMessage}</p>
            )}
          </div>
          {(errorMessage || formData.periodDepasseTroisMois==="oui") && (
              <div className="w-full min-w-0">
              <label
                  htmlFor="dateEntreeEnVigueur"
                  className="block text-sm font-medium text-slate-700"
                >
                  Justification du dépassement du délai <span className="text-xl text-red-900" >*</span> :
                </label>
                <textarea
                  placeholder="Ajoutez une justification..."
    className="mt-1.5 w-full rounded-lg border border-slate-300 bg-white px-3 py-2.5 text-[15px] text-slate-800 shadow-sm outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-100"
                  rows="2"
                  id="justificationOutrepasse"
                  name="justificationOutrepasse"
                  value={formData.justificationOutrepasse}
                  onChange={handleChange}
                  readOnly={isReadOnly}
                ></textarea>
                {renderError("justificationOutrepasse")}
              </div>
          )}
        </div>

        <div className="mt-8 w-full rounded-t-xl bg-gradient-to-r from-[#182a43] to-[#40516a] py-3 shadow-sm">
  <p className="ml-4 flex items-center text-base font-semibold tracking-wide text-white">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="mr-2 h-4 w-4 text-green-400"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M8 10h.01M12 10h.01M16 10h.01M9 16h6M21 12c0 4.418-4.03 8-9 8s-9-3.582-9-8 4.03-8 9-8 9 3.582 9 8z"
      />
    </svg>
    Questions
  </p>
</div>

      <div className="mt-5 w-full divide-y divide-gray-100 rounded-xl border border-gray-200 bg-white px-4 shadow-sm sm:px-5">
      <div className="py-3.5">
        <RadioQuestion
          name="achatsCarteCréditProfessionnelle"
          label="Avez-vous effectué des achats avec votre carte de crédit professionnelle Visa du Conseil?"
          value={formData.achatsCarteCréditProfessionnelle}
          onChange={handleChange}
        />
        </div>

        <div className="py-3.5">
        <RadioQuestion
          name="depensesEtrReclamer"
          label="Avez-vous des dépenses de 407 ETR à réclamer?"
          value={formData.depensesEtrReclamer}
          onChange={handleChange}
        />
      </div>

      <div className="py-3.5">
        <RadioQuestion
          name="depensesActiviteExterne"
          label="Avez-vous effectué des dépenses reliées à une formation, colloque ou activité externe?"
          value={formData.depensesActiviteExterne}
          onChange={handleDepensesActiviteExterneChange}
        />
        </div>
        <div className="py-3.5">
        <RadioQuestion
          name="reclameBoissonAlcoolise"
          label="Avez-vous réclamé de la boisson alcoolisée?"
          value={formData.reclameBoissonAlcoolise}
          onChange={handleChange}
        />
        {/* {formData.reclameBoissonAlcoolise==="oui" && (
          <p className="text-red-500 text-sm mt-2">Aucune boisson alcoolisée ne peut être réclamée.</p>
        )} */}
        {renderError("reclameBoissonAlcoolise")}
      </div>
      </div>

    </div>
  );
};

export default Etape1;
